<template>
	<div class="cont">
		<!-- <img class="b" src="../../../static/yy/wd_hyzx_bj.png" alt=""> -->
		<div class="cont_b"></div>
		<div class="top">
			<div class="top_v1">
				<div class="top_vi_z">
					<img class="top_vi_img" src="../../../static/yy/viptq.png"></img>
					<div class="top_vi_text">遇到同样优秀的Ta</div>
				</div>
				<div class="top_vi_btn" @click="goVipT">
					{{!currentUser.vip?"去开通":"去续费"}}
					<img class="vip_jt" src="../../../static/yy/vip_jt.png"></img>
				</div>
			</div>
			<div class="top_v">
				<div class="tou">
					<img class="tou_img" :src="currentUser.avatarFile"></img>
					<!-- <img class="tou_vip" v-if="currentUser.vip" src="../../../static/yy/vip_yes.png"></img>
					<img class="tou_vip" v-if="!currentUser.vip" src="../../../static/yy/vip_no.png"></img> -->
				</div>
				<div class="user">
					<!-- <div class="user_name">{{currentUser.nickname}}</div> -->
					<div class="user_text" v-if="!currentUser.vip">暂未开通VIP特权</div>
					<div class="user_text2" v-if="currentUser.vip">你的会员于 {{currentUser.vipExpiresTime}} 到期</div>
				</div>
			</div>
		</div>
		<div class="bt">
			<img class="h3_img" src="../../../static/yy/bdqy.png"></img>
		</div>
		<div class="ul">
			<div class="li" v-for="item in vipData" :key="item.name">
				<div class="vi_icon">
					<img class="vi_icon_img" :src="item.icon"></img>
				</div>
				<div class="li_v">
					<div class="li_name">{{item.name}}</div>
					<div class="li_text">{{item.text}}</div>
				</div>
			</div>
		</div>
		
	<!-- 	  <div class="rz_text">小白研遇已经通过国家三级等保认证<br />
		功能持续优化中，充分保障会员权益</div> -->
		<div class="ding">
			<div class="btn" @click="goVipT">
				{{!currentUser.vip?"立即开通":"续费会员"}}
			</div>
			<div class="di">支付即同意 <span data-key="isAgreement" @click="show = true"> 《小白研遇会员协议》</span></div>
			<div class="td_text">已帮助 {{countAllLike}} 人成功脱单</div>
		</div>
		<div  style="height: 30px;"></div>
		<van-overlay :show="show" @click="show = false" :lock-scroll="false">
			<div class="overlay" @click.stop>
				<div class="ck" catchtap="add">
					<div class="ck_h2">{{protocol.title}}</div>
					<div class="ck_tab">
						<div class="ck_text">
							<div class="" v-html="protocol.content"></div>
						</div>
					</div>
					<div class="ck_di">
						<div class="ck_btn ck_btn01" @click="show = false">我知道了</div>
					</div>
				</div>
			</div>
		</van-overlay>
		<div class="loading_vi"  v-show="loading" >
			<div class="loading_vi_z">
				<van-loading size="24px" vertical>加载中...</van-loading>
			</div>
		</div>
		
	</div>
</template>
<script>
	var api = ""
	if(location.host.indexOf("dev") != -1){
		api = "https://dev.kyyy.xiaobaikaoyan.com/api";
	}else{
		api = "https://kyyy.xiaobaitech.cn/api";
	}
	import {
		Overlay,
		Toast,
		Loading 
	} from 'vant';
	import axios from 'axios'
	import {
		formatTime1
	} from '../../util/util'
	export default {
		components: {
			[Overlay.name]: Overlay,
			[Loading.name]: Loading,
		},
		data() {
			return {
				countAllLike:"",
				code: "code",
				show: false,
				protocol: {},
				loading: false,
				currentUser: {},
				vipData: [
					{
						icon: require('../../../static/yy/t06.png'),
						name: "更多推荐",
						text: "每天多推荐5人",
					},
					{
						icon: require('../../../static/yy/t07.png'),
						name: "更多曝光",
						text: "会员优先获得曝光",
					},
					{
						icon: require('../../../static/yy/t08.png'),
						name: "会员筛选",
						text: "按地区筛选推荐",
					},
					{
						icon: require('../../../static/yy/t09.png'),
						name: "精准推荐",
						text: "根据偏好定制推荐",
					},
					{
						icon: require('../../../static/yy/t03.png'),
						name: "超级心动",
						text: "快速联系心动的人",
					},
					{
						icon: require('../../../static/yy/t10.png'),
						name: "一周CP",
						text: "免费参与社交活动",
					},{
						icon: require('../../../static/yy/t01.png'),
						name: "谁喜欢我",
						text: "直接看心动我的人",
					},
					{
						icon: require('../../../static/yy/t02.png'),
						name: "谁访问我",
						text: "直接看访问我的人",
					},
					{
						icon: require('../../../static/yy/t05.png'),
						name: "三天回看",
						text: "直接看近期所有人",
					},
					{
						icon: require('../../../static/yy/t04.png'),
						name: "尊贵身份",
						text: "会员标识突显不同",
					},
				]
			};
		},
		created() {
			let code = this.query1("code");
			let storage = window.sessionStorage;
			let appid = storage.getItem('appid')
			let Openids = storage.getItem('Openids') ? JSON.parse(storage.getItem('Openids')) : {};
			this.Openid = Openids[appid]
			if (Openids[appid]) {
				this.getfindByMpOpenId(Openids[appid])

			} else if (code) {
				this.getOpenId(code)
			}
			// console.log("getOpenid",code,getOpenid)
			this.agreementVIP()
			this.countAllLikeTogether();
		},
		methods: {
			goVipT() {
				// this.$route.push("/vipT")
				this.$router.push('/vipT')
			},
			countAllLikeTogether(){
				axios.get(api + '/api/user/countAllLikeTogether', {})
					.then(res => {
						console.log(res)
						if (res.data && res.data.data) {
							var countAllLike = res.data.data;
							this.countAllLike = countAllLike;
						}
					}, err => {
						console.log(err)
					})
					.catch((error) => {
						console.log(error)
					})
			},
			submit() {
				axios.post(api + "/wx/pay/createOrder/mp?type=1&patform=" + this
						.patform() + "&openid=" + this.Openid, )
					.then(res => {
						console.log(res)
						if (res.data && res.data.data) {
							//调用微信支付接口
							if (typeof(WeixinJSBridge) == "undefined") {
								if (document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
								} else if (document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
								}
							} else {
								this.onBridgeReady(res.data.data);
							}
						} else {
							Toast(res.data.msg)
						}
					}, err => {
						console.log(err)
					})
					.catch((error) => {
						console.log(error)
					})
			},
			onBridgeReady(data) {
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": data.appId, //公众号名称，由商户传入     
						"timeStamp": data.timeStamp, //时间戳，自1970年以来的秒数     
						"nonceStr": data.nonceStr, //随机串     
						"package": data.packageValue, //微信生成的订单号 
						"signType": data.signType, //微信签名方式：     
						"paySign": data.paySign //微信签名 
					}, (res) => {
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							//alert("充值成功！");
							//充值成功，写入数据库(总金额，充值记录)
							// ajaxSyncRequest("wx/chargeRecord", {
							// 	"amount": value
							// }, function(data) {
							// 	if (data.success) {
							// 		window.location.reload();
							// 	} else {
							// 		alert(data.msg);
							// 	}
							// });
							this.getfindByMpOpenId(this.Openid)
						}
					}
				);
			},
			query1(name) {
				const search = location.search.substr(1); // 得到类似于 a=10&b=20&c=30
				const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i'); // i 忽略大小写
				const res = search.match(
					reg); // 返回格式 0: "a=10&" 1: "" 2: "10" 3: "&" groups: undefined index: 0 input: "a=10&b=20&c=30"
				if (res === null) {
					return null
				}
				return res[2];
			},
			patform() { //判断平台的方法
				let patform = "";
				var browser = {
					versions: function() {
						var u = navigator.userAgent,
							app = navigator.appVersion;
						return { //移动终端浏览器版本信息
							trident: u.indexOf('Trident') > -1, //IE内核
							presto: u.indexOf('Presto') > -1, //opera内核
							webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
							gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
							mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
							ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
							android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
							iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
							iPad: u.indexOf('iPad') > -1, //是否iPad
							webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部 
							weixin: u.indexOf('MicroMessenger') > -1, //是否微信
							qq: u.match(/\sQQ/i) == " qq" //是否QQ
						};
					}(),
					language: (navigator.browserLanguage || navigator.language).toLowerCase()
				}

				if (browser.versions.ios) {
					patform = 'iOS'
				} else if (browser.versions.android) {
					patform = 'android'
				} else {
					patform = 'android'
				}
				return patform
			},
			getfindByMpOpenId(Openid) {
				this.loading = true;
				axios.get(api + '/api/user/findByMpOpenId/' + Openid, {})
					.then(res => {
						this.loading = false
						console.log(res)
						if (res.data && res.data.data) {
							var currentUser = res.data.data;
							if (currentUser.vipExpiresTime) {
								currentUser.vipExpiresTime = formatTime1(currentUser.vipExpiresTime, "YYYY-MM-DD")
							}
							this.currentUser = currentUser;
						}
					}, err => {
						this.loading = false
						console.log(err)
					})
					.catch((error) => {
						console.log(error)
					})
			},
			getOpenId(code) {
				let storage = window.sessionStorage;
				let appid = storage.getItem('appid')
				this.loading = true;
				axios.get(api + '/mp/getOpenId/' + appid + '/' + code, {})
					.then(res => {
						if (res.data && res.data.data) {
							var Openid = res.data.data
							this.Openid = Openid;

							var storage = window.sessionStorage;
							let Openids = storage.getItem('Openids') || {}
							Openids[appid] = Openid
							Openids = JSON.stringify(Openids)
							storage.setItem('Openids', Openids);
							this.loading = false;
							this.getfindByMpOpenId(Openid)
						}
						
					}, err => {
						console.log(err)
					})
					.catch((error) => {
						console.log(error)
					})
			},
			agreementVIP() {
				axios.get(api + '/cms/article/byCode/vip-agreement', {})
					.then(res => {
						if (res.data && res.data.data) {
							let {
								content,
								title
							} = res.data.data;
							this.protocol = {
								content,
								title
							}
						}
					}, err => {
						console.log(err)
					})
					.catch((error) => {
						console.log(error)
					})
			},
		}
	}
</script>

<style scoped>
	.loading_vi_z{
		width: 250px;
		height: 250px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 20px;
		background-color: rgba(0, 0, 0, 0.8);
	}
	.loading_vi{
		height: 100vh;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
	}
	.td_text{
	  font-size: 26px;
	  color: #626262;
	  margin-top: 20px;
	  text-align: center;
	}
	.rz_text{
	  width: 670px;
	  height: 126px;
	  background: #E9E9E9;
	  border-radius: 19px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  font-size: 26px;
	  font-weight: normal;
	  color: #957547;
	  line-height: 40px;
	  margin: 38px auto 0;
	}
	.h3_img{
	  width: 670px;
	  height: 44px;
	}
	.vip_jt {
		width: 22px;
		height: 22px;
		background: #483214;
		box-sizing: border-box;
		padding: 6px;
		border-radius: 50%;
		margin-left: 8px;
	}

	.cont_b {
		width: 750px;
		height: 343px;
		position: absolute;
		z-index: -1;
		background: linear-gradient(180deg, #AFB2B5 0%, rgba(229, 229, 230, 0) 100%);
	}

	.top_v1 {
		margin: 30px 38px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.top_vi_img {
		width: 152px;
		height: 38px;
	}

	.top_vi_text {
		color: #897A67;
		font-size: 24px;
		line-height: 24px;
		margin-top: 4px;
	}

	.top_vi_btn {
		width: 144px;
		height: 48px;
		background: linear-gradient(106deg, #FBE7B0 0%, #FCEBCE 100%);
		border-radius: 29px;
		font-size: 24px;
		color: #483214;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cont {
		overflow: hidden;
	}

	.user_text2 {
		font-size: 22px;
		color: #CFC7BD;
		line-height: 37px;
	}

	.overlay {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.ck {
		width: 594px;
		height: 838px;
		background: #FFFFFF;
		border-radius: 20px;
		overflow: hidden;
		padding: 10px 50px;
		box-sizing: border-box;
	}

	.ck_qing {
		font-size: 22px;
		font-weight: 400;
		color: #000000;
		line-height: 34px;
		margin-top: 24px;
	}

	.ck_qing .text {
		color: #FF8100;
	}

	.ck_di {
		margin: 38px 11px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ck_btn {
		width: 320px;
		height: 88px;
		background: #E5E5E7;
		border-radius: 45px;
		text-align: center;
		line-height: 88px;
		color: #98999C;
		font-size: 32px;
	}

	.ck_btn01 {
		background: #86B8FE;
		color: #fff;
	}

	.ck_tab {
		width: 496px;
		height: 554px;
		box-sizing: border-box;
		margin-top: 16px;
		overflow-y: auto;
		over-flew: scroll;
	}

	.ck_h2 {
		font-size: 32px;
		text-align: center;
		font-weight: bold;
		line-height: 37px;
		margin-top: 50px;
	}

	.ck_text {
		font-size: 22px;
		line-height: 40px;
		color: #999BA1;
		margin-top: 8px;

	}

	.ding {
		width: 100%;
	}

	.btn {
		width: 410px;
		  height: 88px;
		  background: #000;
		  border-radius: 45px;
		  text-align: center;
		  font-size: 32px;
		  line-height: 88px;
		  color: #fff;
		  margin: 34px auto 0;
	}

	.di {
		color: #898989;
		font-size: 22px;
		text-align: center;
		margin-top: 28px;
	}

	.di span {
		color: #4E9CE5;
	}

	.vi_icon {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #716F76;
		font-size: 36px;
		border:3px solid #49474D;
		padding: 17px;
		box-sizing: border-box;
	}

	.vi_icon_img {
		width: 36px;
		height: 36px;
	}

	.li {
		display: flex;
		align-items: center;
		margin-top: 50px;
		width: 50%;
	}

	.li_v {
		margin-left: 20px;
	}

	.li_name {
		line-height: 42px;
		font-size: 30px;
		font-weight: bold;
	}

	.li_text {
		font-size: 22px;
		line-height: 30px;
		color: #B8BCBF;
	}

	.ul {
		margin: 34px 40px 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 22px;
		padding: 0 32px 42px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.b {
		width: 100%;
		height: 254px;
		position: absolute;
		z-index: -1;
	}

	.bt {
		margin: 70px 0 0;
		color: #A9AEB2;
		font-size: 26px;
		line-height: 40px;
		text-align: center;
	}

	.top_z {
		width: 108px;
		height: 96px;
		position: absolute;
		bottom: 0;
		right: 15px;
	}

	.top_v {
		padding: 0 37px;
		display: flex;
		align-items: center;
		margin-top: 46px;
	}

	.user {
		margin-left: 18px;
		color: #fff;
	}

	.user_name {
		font-size: 40px;
		font-weight: 500;
		line-height: 40px;
	}

	.user_text {
		color: #858B9D;
		line-height: 30px;
		font-size: 22px;
		margin-top: 10px;
	}

	.tou {
		border-radius: 50%;
		border: 2px solid #fff;
		width: 37px;
		height: 37px;
		position: relative;
	}

	.tou_img {
		width: 37px;
		height: 37px;
		border-radius: 50%;
	}

	.tou_vip {
		width: 80px;
		height: 50px;
		position: absolute;
		left: 1px;
		bottom: -30px;
	}

	.zt {
		width: 106px;
		height: 42px;
		background: #91A6CE;
		border-radius: 0px 24px 0px 24px;
		color: #fff;
		text-align: center;
		line-height: 42px;
		font-size: 24px;
		position: absolute;
		right: -4px;
		top: -4px;
	}

	.top {
		width: 690px;
		height: 221px;
		background: linear-gradient(181deg, #2A2A2A 0%, #2C2C2C 100%);
		border-radius: 24px 24px 0px 0px;
		margin: 74px auto 0;
		border-radius: 20px;
		box-shadow: 0px 0px 20px 0px #959DAD;
		overflow: hidden;
	}
</style>
